module.exports = __webpack_public_path__ + "static/media/Trash_Can_Icon_Red.76e310da.svg";